/* ============================================================
   CORPULENCIA — JS propio (vanilla, sin librerias)
   Un init por componente; cada uno comprueba si su elemento
   existe antes de actuar.
   ============================================================ */
(function () {
  "use strict";

  // Marca que el JS esta vivo: el CSS solo oculta los .cp-reveal si existe .cp-js.
  document.documentElement.classList.add("cp-js");

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reveal al scroll (observer compartido) ---------- */
  function initReveal() {
    var els = document.querySelectorAll(".cp-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("cp-in"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add("cp-in");
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
    // Red de seguridad: si algo impide que el observer dispare, muestra todo.
    setTimeout(function () {
      document.querySelectorAll(".cp-reveal:not(.cp-in)").forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) el.classList.add("cp-in");
      });
    }, 2500);
  }

  /* ---------- Parallax suave del hero ---------- */
  function initHeroParallax() {
    var img = document.querySelector(".cp-hero__media img");
    if (!img || reduce) return;
    var wrap = img.closest(".cp-hero");
    var ticking = false;
    function update() {
      var r = wrap.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var progress = (r.top + r.height) / (vh + r.height); // 1 -> 0
      var shift = (0.5 - progress) * 60; // px
      img.style.transform = "translate3d(0," + shift.toFixed(2) + "px,0) scale(1.06)";
      ticking = false;
    }
    function onScroll() {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    update();
  }

  /* ---------- Escena sticky de detalle ---------- */
  function initDetail() {
    var scene = document.querySelector("[data-cp-detail]");
    if (!scene) return;
    var rows = scene.querySelectorAll(".cp-detail__row");
    var imgs = scene.querySelectorAll(".cp-detail__stage img");
    if (!rows.length || !imgs.length) return;

    function activate(i) {
      rows.forEach(function (r, n) { r.classList.toggle("cp-active", n === i); });
      imgs.forEach(function (im, n) { im.classList.toggle("cp-on", n === i); });
    }
    activate(0);

    if (!("IntersectionObserver" in window)) { return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          var idx = parseInt(e.target.getAttribute("data-cp-row"), 10) || 0;
          activate(idx);
        }
      });
    }, { threshold: 0.6, rootMargin: "-20% 0px -40% 0px" });
    rows.forEach(function (r) { io.observe(r); });
  }

  /* ---------- Selector de color ---------- */
  function initColors() {
    var comp = document.querySelector("[data-cp-colors]");
    if (!comp) return;
    var swatches = comp.querySelectorAll(".cp-swatch");
    var imgs = comp.querySelectorAll(".cp-colors__stage img");
    var nameOut = comp.querySelector(".cp-colors__name");
    if (!swatches.length) return;

    function pick(i) {
      swatches.forEach(function (s, n) { s.classList.toggle("cp-on", n === i); });
      imgs.forEach(function (im, n) { im.classList.toggle("cp-on", n === i); });
      if (nameOut) nameOut.textContent = swatches[i].getAttribute("data-cp-name") || "";
    }
    swatches.forEach(function (s, i) {
      s.addEventListener("click", function () { pick(i); });
      s.addEventListener("mouseenter", function () { pick(i); });
    });
    pick(0);
  }

  /* ---------- FAQ acordeon ---------- */
  function initFaq() {
    var lists = document.querySelectorAll("[data-cp-faq]");
    if (!lists.length) return;
    lists.forEach(function (list) {
      var items = list.querySelectorAll(".cp-faq__item");
      items.forEach(function (item) {
        var q = item.querySelector(".cp-faq__q");
        if (!q) return;
        q.addEventListener("click", function () {
          var open = item.classList.contains("cp-open");
          items.forEach(function (o) { o.classList.remove("cp-open"); });
          if (!open) item.classList.add("cp-open");
        });
      });
    });
  }

  /* ---------- Contador animado ---------- */
  function initCountUp() {
    var nums = document.querySelectorAll("[data-cp-count]");
    if (!nums.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      nums.forEach(function (n) { n.textContent = n.getAttribute("data-cp-count"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var el = e.target;
        var target = parseFloat(el.getAttribute("data-cp-count")) || 0;
        var suffix = el.getAttribute("data-cp-suffix") || "";
        var dur = 1400, t0 = performance.now();
        function tick(now) {
          var p = Math.min((now - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = Math.round(target * eased).toLocaleString("es-CL") + suffix;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      });
    }, { threshold: 0.6 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Galeria de producto ---------- */
  function initProductGallery() {
    var gal = document.querySelector("[data-cp-gallery]");
    if (!gal) return;
    var main = gal.querySelector(".cp-pgallery__main img");
    var thumbs = gal.querySelectorAll(".cp-pgallery__thumb");
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener("click", function () {
        var full = t.getAttribute("data-cp-full");
        if (full) main.src = full;
        thumbs.forEach(function (o) { o.classList.remove("cp-on"); });
        t.classList.add("cp-on");
      });
    });
  }

  /* ---------- Variantes de producto ---------- */
  function initProductForm() {
    var root = document.querySelector("[data-cp-product]");
    if (!root) return;
    var dataEl = root.querySelector("[data-cp-variants]");
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var radios = root.querySelectorAll("input[data-cp-option]");
    var idInput = root.querySelector('input[name="id"]');
    var priceOut = root.querySelector("[data-cp-price]");
    var compareOut = root.querySelector("[data-cp-compare]");
    var offerPill = root.querySelector("[data-cp-offer]");
    var addBtn = root.querySelector("[data-cp-add]");
    var soldText = root.getAttribute("data-cp-sold") || "Agotado";
    var addText = root.getAttribute("data-cp-addtext") || "Añadir al carrito";
    var money = root.getAttribute("data-cp-money") || "${{amount}}";

    // posiciones de opciones presentes
    var positions = [];
    Array.prototype.forEach.call(radios, function (r) {
      var p = r.getAttribute("data-cp-option");
      if (positions.indexOf(p) === -1) positions.push(p);
    });

    function fmt(cents) {
      var val = (cents / 100);
      var s = val.toLocaleString("es-CL", { minimumFractionDigits: 0, maximumFractionDigits: 2 });
      return money.replace("{{amount}}", s).replace("{{ amount }}", s)
                  .replace("{{amount_no_decimals}}", s).replace("{{ amount_no_decimals }}", s);
    }
    function currentOptions() {
      return positions.map(function (p) {
        var checked = root.querySelector('input[data-cp-option="' + p + '"]:checked');
        return checked ? checked.value : null;
      });
    }
    function match() {
      var opts = currentOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function update() {
      var v = match();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = soldText; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (priceOut) priceOut.textContent = fmt(v.price);
      if (compareOut) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          compareOut.textContent = fmt(v.compare_at_price);
          compareOut.style.display = "";
          if (offerPill) {
            var pct = Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price);
            offerPill.textContent = "-" + pct + "%";
            offerPill.style.display = "";
          }
        } else {
          compareOut.style.display = "none";
          if (offerPill) offerPill.style.display = "none";
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? addText : soldText;
      }
    }
    // Al elegir color: cambiar la foto principal de la galeria
    var galMain = document.querySelector("[data-cp-gallery] .cp-pgallery__main img");
    var galThumbs = document.querySelectorAll("[data-cp-gallery] .cp-pgallery__thumb");
    function swapColorImage(radio) {
      var url = radio.getAttribute("data-cp-colorimg");
      if (!url || !galMain) return;
      galMain.src = url;
      galThumbs.forEach(function (t) {
        var isMatch = (t.getAttribute("data-cp-full") || "").split("?")[0] === url.split("?")[0];
        t.classList.toggle("cp-on", isMatch);
      });
    }

    Array.prototype.forEach.call(radios, function (r) {
      r.addEventListener("change", function () {
        update();
        if (r.checked) swapColorImage(r);
      });
    });
    update();
  }

  document.addEventListener("DOMContentLoaded", function () {
    initReveal();
    initHeroParallax();
    initDetail();
    initColors();
    initFaq();
    initCountUp();
    initProductGallery();
    initProductForm();
  });
})();
